import { GetAbilitiesModelView } from 'abi-genome-common-types';
import { type AxiosError, type AxiosInstance, isAxiosError } from 'axios';

import type {
  LogProxyActivationPayload,
  LogProxyActivationResponse,
} from './types/genome';

export async function getUserAbilities(
  genomeApi: AxiosInstance,
  token: string
): Promise<GetAbilitiesModelView | AxiosError> {
  try {
    const response = await genomeApi.get<GetAbilitiesModelView>(`abilities`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (err) {
    if (isAxiosError(err)) return err;
    throw new Error('Unable to get user abilities');
  }
}

export async function logProxyActivation(
  genomeApi: AxiosInstance,
  token: string,
  payload: LogProxyActivationPayload,
  forwardedHeaders: Record<string, string> = {}
): Promise<LogProxyActivationResponse | AxiosError> {
  try {
    const response = await genomeApi.post<LogProxyActivationResponse>(
      'proxy/log-activation',
      payload,
      { headers: { ...forwardedHeaders, Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (err) {
    if (isAxiosError(err)) return err;
    throw new Error('Unable to log proxy activation');
  }
}
